<template>
  <div v-if="props.chips.length" class="active-chips" role="list">
    <button
      v-for="chip in props.chips"
      :key="chip.key"
      type="button"
      class="active-chips__item"
      role="listitem"
      :aria-label="`${chip.label}: ${chip.value}`"
      @click="$emit('remove', chip.key)"
    >
      <span class="active-chips__text text-body-2">
        <span class="active-chips__label">{{ chip.label }}:</span>
        <span class="active-chips__value">{{ chip.value }}</span>
      </span>
      <base-icon name="base/Close" size="14px" color="var(--surface)" />
    </button>
    <button
      type="button"
      class="active-chips__clear text-body-2 text-bold"
      @click="$emit('clear-all')"
    >
      {{ $t("directory.filters.clear_all") }}
    </button>
  </div>
</template>

<script setup lang="ts">
export interface ActiveChip {
  key: string;
  label: string;
  value: string;
}

interface Props {
  chips: ActiveChip[];
}

const props = defineProps<Props>();

defineEmits<{
  remove: [key: string];
  "clear-all": [];
}>();
</script>

<style scoped lang="scss">
.active-chips {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  &__item {
    flex-shrink: 0;
    @include drop-button-styles;
    @include ds-chip-removable;

    :deep(svg path) {
      fill: var(--surface);
    }
  }

  &__text {
    display: inline-flex;
    gap: 4px;
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__label {
    opacity: 0.6;
  }

  &__value {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__clear {
    @include drop-button-styles;
    @include ds-tertiary;
    color: var(--text-secondary);
    padding: 0 8px;
    flex-shrink: 0;
    height: 36px;
    text-underline-offset: 2px;
    &:hover {
      color: var(--text-primary);
    }
  }
}
</style>
